/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgCheckboxChecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M4 0h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm8.623 5.235l-1.197-1.173a.217.217 0 0 0-.304 0L6.065 9.006a.217.217 0 0 1-.304 0L4.564 7.832a.217.217 0 0 0-.304 0L3.063 9.006a.206.206 0 0 0 0 .296l2.698 2.636a.217.217 0 0 0 .304 0l6.558-6.41a.206.206 0 0 0 0-.293z' />
  </svg>
)
export default SvgCheckboxChecked
